export class IconBox {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        iconBoxWithDetailView: '.icon-box--detail-view',
        front: '.icon-box__front',
        icon: '.icon-box__icon',
        closeButton: '.icon-box__close',
        detailView: '.icon-box__detail-view'
      },
      classes: {
        jsInitialized: 'icon-box--js-initialized',
        iconBoxWithDetailViewShowDetail: 'icon-box--show-detail',
        detailViewOpen: 'icon-box__detail-view--open'
      }
    },
    settings)
  }

  init () {
    const that = this

    if ($(that.options.selectors.front).length > 0) {
      that.resizeFlip()

      setTimeout(function () {
        that.resizeFlip()
      }, 500)

      that.addEvents()
    }
  }

  resizeFlip () {
    const that = this
    const flipFronts = $(that.options.selectors.front)

    flipFronts
      .each(function () {
        const front = $(this)
        const parenticonBoxWithDetailView = front.closest(that.options.selectors.iconBoxWithDetailView)

        parenticonBoxWithDetailView
          .removeClass(that.options.classes.jsInitialized)

        parenticonBoxWithDetailView
          .css('height', front.outerHeight() + 'px')

        parenticonBoxWithDetailView
          .addClass(that.options.classes.jsInitialized)
      })
  }

  addEvents () {
    const that = this
    const iconBoxWithDetailView = $(that.options.selectors.iconBoxWithDetailView)
    const icons = iconBoxWithDetailView.find(that.options.selectors.icon)
    const closeButtons = $(that.options.selectors.closeButton)
    let resizeTimer

    $(window)
      .resize(function () {
        clearTimeout(resizeTimer)

        resizeTimer = setTimeout(function () {
          that.resizeFlip()
        }, 250)
      })

    icons
      .on({
        click: function (event) {
          const icon = $(this)
          const parentIconBoxWithDetailView = icon.closest(that.options.selectors.iconBoxWithDetailView)
          const allDetailViews = parentIconBoxWithDetailView.find(that.options.selectors.detailView)
          const detailView = allDetailViews.filter($('[id="' + icon.attr('href').substring(1) + '"]'))

          event.preventDefault()

          allDetailViews
            .removeClass(that.options.classes.detailViewOpen)

          detailView
            .addClass(that.options.classes.detailViewOpen)

          parentIconBoxWithDetailView
            .addClass(that.options.classes.iconBoxWithDetailViewShowDetail)
        }
      })

    closeButtons
      .on({
        click: function (event) {
          const closeButton = $(this)
          const parentIconBoxWithDetailView = closeButton.closest(that.options.selectors.iconBoxWithDetailView)
          const allDetailViews = parentIconBoxWithDetailView.find(that.options.selectors.detailView)

          event.preventDefault()

          allDetailViews
            .removeClass(that.options.classes.detailViewOpen)

          parentIconBoxWithDetailView
            .removeClass(that.options.classes.iconBoxWithDetailViewShowDetail)
        }
      })
  }
}

export default IconBox
